<template>
    <div class="main">
        <!-- 頁首 -->
        <Header :title="title" :isBack="true" />

        <!-- 主體 -->
        <div class="mainContent">
            <!-- 主選單 -->
            <div class="agri-result-group pwa pb-1">
                <b-container> 

                    <!-- 標題 -->
                    <PwaTitle :textTitle="group_data.title" :showMore="false"></PwaTitle>
                    <!-- 手機資料 -->
                    <OptionsGroup>
                        <!-- 允許通知 -->
                        <OptionsItem classIcon="fa-solid fa-bell" :textTitle='group_data.notification.title' :badge="notificationStatusBadge" @clickItem="onNotificationSettings()"></OptionsItem><hr />
                        <!-- 清除暫存資料 -->
                        <OptionsItem v-if="!isCordovaWebView" classIcon="fa-solid fa-trash" :textTitle='group_data.clear.title' @clickItem="onDataClear()"></OptionsItem>
                        <!-- 登出 -->
                        <OptionsItem v-if="isCordovaWebView" classIcon="fa-solid fa-sign-out" :textTitle='group_data.sign_out.title' @clickItem="onSignOut()"></OptionsItem>
                        <!-- 刪除帳號並強制登出 -->
                        <OptionsItem v-if="isCordovaWebView && !isVisitor()" classIcon="fa-solid fa-trash" :textTitle='group_data.delete.title' @clickItem="onDeleteAccount()"></OptionsItem>
                    </OptionsGroup>
                    
                </b-container>
            </div> 
        </div>

        <!-- 彈出視窗(通知設定) -->
        <b-modal
            v-model="modal.notification.show"
            title="通知設定"
            size="lg"
            hide-footer
            centered>
            <NotificationSettings />
        </b-modal>

    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import Header from '@/components/pwa/Header.vue'
import PwaTitle from '@/components/pwa/PwaTitle.vue'
import OptionsGroup from '@/components/pwa/OptionsGroup.vue'
import OptionsItem from '@/components/pwa/OptionsItem.vue'
import NotificationSettings from '@/components/pwa/NotificationSettings.vue'
export default {
    created() {
        window.vue = this;
        if(!window.checkLogin()){ window.setPage("login");}               
    },  
    components: {
        Header,
        PwaTitle,
        OptionsGroup,
        OptionsItem,
        NotificationSettings
    },
    data(){
        return {

            //api 取得最大種植面積
            apiDeleteAccountUser: (data) => this.userRequest.post("/API/Default/DeleteAccountUser", data),

            //判別是否為app
            isCordovaWebView:false,
            //標題
            title: "相關設定",
            //群組(手機資料)
            group_data:{
                title:"手機資料",
                notification:{
                    title:"允許通知"
                },
                clear:{
                    title:"清除暫存資料"
                },
                sign_out:{
                    title:"登出"
                },
                delete:{
                    title:"刪除帳號並強制登出",
                    message:"您確定要刪除帳號嗎?"
                }
            },
            //彈出視窗
            modal:{
                //允許通知
                notification:{
                    show: false
                }
            }
        }
    },
    computed: {
        ...mapState('notification', ['permission', 'fcmToken', 'isSupported']),
        ...mapGetters('notification', ['hasPermission']),

        // 通知狀態徽章
        notificationStatusBadge() {
            if (this.isSupported === null) {
                return { text: '載入中', variant: 'secondary' }
            }
            if (this.isSupported === false) {
                return { text: '不支援', variant: 'warning' }
            }
            if (this.hasPermission && this.fcmToken) {
                return { text: '已啟用', variant: 'success' }
            }
            return { text: '未啟用', variant: 'secondary' }
        }
    },
    mounted(){

        //判別是否為app(只有app才會有 isCordovaWebView 狀態)
        this.isCordovaWebView = localStorage.getItem("isCordovaWebView") === "true";
    
    },
    methods: {

        //點選允許通知
        onNotificationSettings() {
            this.modal.notification.show = true
        },

        //點選清除暫存資料
        async onDataClear(){ 
            
            var yes = confirm('你確定清除暫存資料嗎？');

            if (yes) {
                //alert('你按了確定按鈕');
                try {
                    // 1. 清除 Service Worker 的 Cache Storage
                    const keys = await caches.keys();
                    await Promise.all(keys.map(key => caches.delete(key)));

                    // 2. 清除 localStorage (不能清空全部，因為有些要判別是否為行動裝置及推播功能)
                    //localStorage.clear();
                    localStorage.removeItem("AC_GROUP_ID");
                    localStorage.removeItem("TokenID");
                    localStorage.removeItem("disposable_line");
                    localStorage.removeItem("username");
                
                    // 3. 清除 sessionStorage
                    sessionStorage.clear();

                    // 4. 清除 IndexedDB
                    if (window.indexedDB && indexedDB.databases) {
                        // 有些瀏覽器支援列出所有 DB
                        const dbs = await indexedDB.databases();
                        dbs.forEach(db => {
                            indexedDB.deleteDatabase(db.name);
                        });
                    } else {
                        // 若瀏覽器不支援 indexedDB.databases()，就只能刪已知的 DB 名稱
                        indexedDB.deleteDatabase("my-db-name");
                    }

                    alert("快取與資料已清除，將重新載入頁面！");
                    location.reload(true);
                } catch (err) {
                    console.error("清除快取錯誤:", err);
                    alert("清除失敗，請再試一次");
                }

            } else {
                //alert('你按了取消按鈕');
            }
        },

        //點選登出
        onSignOut() {
            // 1. 清除 localStorage (不能清空全部，因為有些要判別是否為行動裝置及推播功能)
            //localStorage.clear();
            localStorage.removeItem("AC_GROUP_ID");
            localStorage.removeItem("TokenID");
            localStorage.removeItem("disposable_line");
            localStorage.removeItem("username");

            // 2. 清除 sessionStorage
            sessionStorage.clear();
            alert("登出成功，將重新載入頁面！");
            location.reload(true);
        },

        //點選刪除帳號並強制登出
        onDeleteAccount() {

            var yes = confirm(this.group_data.delete.message);

            if (yes) 
            {
                //你按了確定按鈕
                this.apiDeleteAccountUser({

                    TokenID:sessionStorage.getItem("TokenID")
                })
                .then((res)=>{

                    console.log(res);
                    // 1. 清除 localStorage (不能清空全部，因為有些要判別是否為行動裝置及推播功能)
                    //localStorage.clear();
                    localStorage.removeItem("AC_GROUP_ID");
                    localStorage.removeItem("TokenID");
                    localStorage.removeItem("disposable_line");
                    localStorage.removeItem("username");

                    // 2. 清除 sessionStorage
                    sessionStorage.clear();
                    alert("帳號刪除成功，將重新載入頁面！");
                    location.reload(true);
                })
                .catch((err)=> {
                    console.log(err);
                }); 

            } else {
                //你按了取消按鈕 
            }

        },

        // 判斷是否為訪客
        isVisitor() {
            return localStorage.getItem('TokenID') == '-1';
        },

    }
}
</script>
<style scoped>

</style>